import { render, staticRenderFns } from "./content2.vue?vue&type=template&id=dd8b6e1a&scoped=true&"
import script from "./content2.vue?vue&type=script&lang=js&"
export * from "./content2.vue?vue&type=script&lang=js&"
import style0 from "./content2.vue?vue&type=style&index=0&id=dd8b6e1a&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dd8b6e1a",
  null
  
)

export default component.exports